import { FB_APP_VERSION } from '../constants/config';

declare let __PROD_API__: boolean;
declare let __SPORTS_API_URL__: string;
declare let __SRS_API_URL__: string;

const sportsApiHost = String(__SPORTS_API_URL__);
const sportsApiProtocol = sportsApiHost.includes('localhost')
    ? 'http'
    : 'https';

export const sportsApiUrl = `${sportsApiProtocol}://${sportsApiHost}/v1`;

// OpenAPI spec served by sports-api at /v1/openapi.json. sportsApiUrl already
// includes the /v1 prefix, so this resolves to `${proto}://${host}/v1/openapi.json`.
export const openApiSpecUrl = `${sportsApiUrl}/openapi.json`;

export const srsProdURL =
    'https://5p0gkjhxt2.execute-api.us-east-1.amazonaws.com/prod';
export const srsStageURL =
    'https://ot8ih415wa.execute-api.us-east-1.amazonaws.com/stage';

const srsDevUrl = String(
    typeof __SRS_API_URL__ === 'undefined' ? '' : __SRS_API_URL__ || '',
).replace(/\/+$/, '');

export const srsApiUrl = __PROD_API__ ? srsProdURL : srsDevUrl || srsStageURL;

export const fbSdkURL = `https://graph.facebook.com/${FB_APP_VERSION}`;

export const authUrl = __PROD_API__
    ? 'https://auth.rmdevops.com'
    : 'https://auth-dev.rmdevops.com';

export const insightsUrl = __PROD_API__
    ? 'https://insights.rmdevops.com'
    : 'https://insights-dev.rmdevops.com';
